import React from "react";
import {
  WiDaySunny,
  WiNightClear,
  WiDayCloudy,
  WiNightCloudyHigh,
  WiCloud,
  WiFog,
  WiSnowflakeCold,
  WiNightAltThunderstorm,
  WiThunderstorm,
  WiNightAltRainMix,
  WiDayRainMix,
  WiNightAltRain,
  WiRain,
  WiNightCloudy,
  WiCloudy,
  WiNightAltCloudy,
} from "react-icons/wi";

export default function WeatherIcon(props) {
  const codeMapping = {
    "01d": WiDaySunny,
    "01n": WiNightClear,
    "02d": WiDayCloudy,
    "02n": WiNightCloudyHigh,
    "03d": WiCloud,
    "03n": WiNightAltCloudy,
    "04d": WiCloudy,
    "04n": WiNightCloudy,
    "09d": WiRain,
    "09n": WiNightAltRain,
    "10d": WiDayRainMix,
    "10n": WiNightAltRainMix,
    "11d": WiThunderstorm,
    "11n": WiNightAltThunderstorm,
    "13d": WiSnowflakeCold,
    "13n": WiSnowflakeCold,
    "50d": WiFog,
    "50n": WiFog,
  };
  let Icon = codeMapping[props.info];
  React.createElement(Icon, {});

  return <Icon />;
}
